import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import SortFilters from 'components/filters/SortFilters';

import styles from './styles.module.scss';

const Controls = ({ urlParams, handleFilterChange }) => {
	const filters = {
		..._(urlParams).omit('page', 'limit')
	};

	return (
		<div className={styles.Controls}>
			<SortFilters
				onFilterChange={handleFilterChange}
				currentSort={filters.sort}
			/>
		</div>
	);
};

Controls.propTypes = {
	urlParams: PropTypes.object.isRequired,
	handleFilterChange: PropTypes.func
};

export default Controls;
